import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/WoveLogo_Tablet.svg'
import _imports_1 from '../../assets/Arrow.webp'
import _imports_2 from '../../assets/Frame 1672.webp'
import _imports_3 from '../../assets/Frame 1672.webp'


const _withScopeId = n => (_pushScopeId("data-v-c3690318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header-mobile-menu-item app-header-mobile-menu-item-title" }, " Infrastructure ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header-mobile-menu-item app-header-mobile-menu-item-title" }, " New Building ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header-mobile-menu-item app-header-mobile-menu-item-title" }, " Existing Building ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-header-mobile-menu-item app-header-mobile-menu-item-title" }, " Solutions ", -1))
const _hoisted_6 = { class: "app-header-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-menu-box" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "header-menu-title header-menu-item pointer",
    href: "/infrastructure"
  }, "Infrastructure"),
  /*#__PURE__*/_createElementVNode("div", { class: "header-menu" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "header-menu-item pointer",
      href: "/infrastructure"
    }, "Transportation")
  ])
], -1))
const _hoisted_8 = { class: "header-menu-box header-menu-line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/governmentAndEnterpriseOffice",
  class: "header-menu-title header-menu-item pointer"
}, "New Building", -1))
const _hoisted_10 = { class: "header-menu" }
const _hoisted_11 = { class: "header-menu-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/existingBuilding",
  class: "header-menu-title header-menu-item pointer"
}, "Existing Building", -1))
const _hoisted_13 = { class: "header-menu" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"header-menu-box header-menu-flex-column-center\" data-v-c3690318><a class=\"header-menu-title header-menu-item pointer\" href=\"/iot\" data-v-c3690318>IoT</a><a class=\"header-menu-title header-menu-item pointer\" href=\"/software\" data-v-c3690318>Software</a><a class=\"header-menu-title header-menu-item pointer\" href=\"/hardware\" data-v-c3690318>Hardware</a><a class=\"header-menu-title header-menu-item pointer\" href=\"/meter\" data-v-c3690318>Intelligent Watt-Hour Meter</a></div>", 1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  src: _imports_0,
  class: "header-logo"
}
const _hoisted_20 = ["poster", "src"]
const _hoisted_21 = { class: "header-content" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "header-content-arrow"
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "header-content-arrow"
}, null, -1))
const _hoisted_24 = { class: "header-container-Tablet header-container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "header-logo-Tablet"
  })
], -1))
const _hoisted_26 = { class: "header-container-Mobile header-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "header-logo-Mobile"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactUsButton = _resolveComponent("ContactUsButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = () => { this.mobileMenuActive = false }),
      class: _normalizeClass({
            'app-header-mobile-menu-mask': true,
            'active': _ctx.mobileMenuActive,
        })
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass({
            'app-header-mobile-menu': true,
            'active': _ctx.mobileMenuActive,
            'font-Headline-4': true,
        })
    }, [
      _createElementVNode("a", {
        href: "/",
        onClick: _cache[1] || (_cache[1] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
        class: "app-header-mobile-menu-item"
      }, " Home "),
      _createElementVNode("a", {
        href: "/about",
        onClick: _cache[2] || (_cache[2] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
        class: "app-header-mobile-menu-item"
      }, " About Us "),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("a", {
          href: "/infrastructure",
          onClick: _cache[3] || (_cache[3] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Transportation ")
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("a", {
          href: "/governmentAndEnterpriseOffice",
          onClick: _cache[4] || (_cache[4] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Government and Enterprise Office "),
        _createElementVNode("a", {
          href: "/education",
          onClick: _cache[5] || (_cache[5] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Education "),
        _createElementVNode("a", {
          href: "/retail",
          onClick: _cache[6] || (_cache[6] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Retail "),
        _createElementVNode("a", {
          href: "/healthcare",
          onClick: _cache[7] || (_cache[7] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Healthcare "),
        _createElementVNode("a", {
          href: "/hospitality",
          onClick: _cache[8] || (_cache[8] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Hospitality ")
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("a", {
          href: "/BuildingEquipmentAndFacilitiesOperation",
          onClick: _cache[9] || (_cache[9] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Building Equipment and Facilities Operation "),
        _createElementVNode("a", {
          href: "/IntegratedOperationsAndManagementPlatform",
          onClick: _cache[10] || (_cache[10] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Integrated Operations and Management Platform "),
        _createElementVNode("a", {
          href: "/SmartPropertyManagementPlatform",
          onClick: _cache[11] || (_cache[11] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Smart Property Management Platform "),
        _createElementVNode("a", {
          href: "/SmartDetentionCenterManagementPlatform",
          onClick: _cache[12] || (_cache[12] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Smart Detention center Management Platform ")
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createElementVNode("a", {
          href: "/iot",
          onClick: _cache[13] || (_cache[13] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " IoT "),
        _createElementVNode("a", {
          href: "/software",
          onClick: _cache[14] || (_cache[14] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Software "),
        _createElementVNode("a", {
          href: "/hardware",
          onClick: _cache[15] || (_cache[15] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Hardware "),
        _createElementVNode("a", {
          href: "/meter",
          onClick: _cache[16] || (_cache[16] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          class: "app-header-mobile-menu-item app-header-mobile-menu-item-child"
        }, " Intelligent Watt-Hour Meter ")
      ])
    ], 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        onMouseover: _cache[26] || (_cache[26] = () => { this.active = 'Building Development' }),
        onMouseleave: _cache[27] || (_cache[27] = () => { this.active = '' }),
        class: _normalizeClass({
                'header-menu-container': true,
                'header-menu-building': true,
                 'active': _ctx.active === 'Building Development'
            })
      }, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/governmentAndEnterpriseOffice",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.linkTo('/governmentAndEnterpriseOffice', {})))
            }, "Government and Enterprise Office"),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/education",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.linkTo('/education', {})))
            }, "Education"),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/retail",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.linkTo('/retail', {})))
            }, "Retail"),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/healthcare",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.linkTo('/healthcare', {})))
            }, "Healthcare"),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/hospitality",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.linkTo('/hospitality', {})))
            }, "Hospitality")
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/BuildingEquipmentAndFacilitiesOperation",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.linkTo('/BuildingEquipmentAndFacilitiesOperation', {})))
            }, [
              _createTextVNode("Building Equipment and Facilities"),
              _hoisted_14,
              _createTextVNode("Operation")
            ]),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/IntegratedOperationsAndManagementPlatform",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.linkTo('/IntegratedOperationsAndManagementPlatform', {})))
            }, [
              _createTextVNode("Integrated Operations and Management"),
              _hoisted_15,
              _createTextVNode("Platform")
            ]),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/SmartPropertyManagementPlatform",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.linkTo('/SmartPropertyManagementPlatform', {})))
            }, "Smart Property Management Platform"),
            _createElementVNode("a", {
              class: "header-menu-item pointer",
              href: "/SmartDetentionCenterManagementPlatform",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.linkTo('/SmartDetentionCenterManagementPlatform', {})))
            }, [
              _createTextVNode("Smart Detention center Management"),
              _hoisted_16,
              _createTextVNode("Platform")
            ])
          ])
        ])
      ], 34),
      _createElementVNode("div", {
        onMouseover: _cache[28] || (_cache[28] = () => { this.active = 'Solutions' }),
        onMouseleave: _cache[29] || (_cache[29] = () => { this.active = '' }),
        class: _normalizeClass({
                    'header-menu-container': true,
                    'header-menu-solutions': true,
                    'box-solutions': true,
                     'active': _ctx.active === 'Solutions'
                })
      }, _hoisted_18, 34),
      _createElementVNode("div", {
        class: "header-container-Desktop header-container",
        onMouseleave: _cache[39] || (_cache[39] = () => { this.active = ''; })
      }, [
        _createElementVNode("a", {
          href: "/",
          onMouseenter: _cache[31] || (_cache[31] = () => { this.active = ''; })
        }, [
          (_ctx.isSafiri)
            ? (_openBlock(), _createElementBlock("img", _hoisted_19))
            : _createCommentVNode("", true),
          (!_ctx.isSafiri)
            ? (_openBlock(), _createElementBlock("video", {
                key: 1,
                id: "header_logo_gif",
                class: "header-logo-gif",
                poster: require('../../assets/WoveLogo_Tablet.svg'),
                src: require('../../assets/gif/Wove logo animation.webm'),
                onMouseenter: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.handleMouseEnterLogo && _ctx.handleMouseEnterLogo(...args))),
                muted: "",
                controls: false,
                disablepictureinpicture: ""
              }, null, 40, _hoisted_20))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("a", {
            href: "/",
            onMouseenter: _cache[32] || (_cache[32] = () => { this.active = ''; }),
            class: "header-content-text"
          }, "Home", 32),
          _createElementVNode("a", {
            href: "/about",
            onMouseenter: _cache[33] || (_cache[33] = () => { this.active = ''; }),
            class: "header-content-text"
          }, "About Us", 32),
          _createElementVNode("div", {
            onMouseover: _cache[34] || (_cache[34] = () => { this.active = 'Building Development' }),
            onClick: _cache[35] || (_cache[35] = () => { this.active = 'Building Development' }),
            class: _normalizeClass({
                            'header-content-text': true,
                            'active': _ctx.active === 'Building Development'
                        })
          }, [
            _createTextVNode(" Building Development "),
            _hoisted_22
          ], 34),
          _createElementVNode("div", {
            onMouseover: _cache[36] || (_cache[36] = () => { this.active = 'Solutions' }),
            onClick: _cache[37] || (_cache[37] = () => { this.active = 'Solutions' }),
            class: _normalizeClass({
                            'header-content-text': true,
                            'active': _ctx.active === 'Solutions'
                        })
          }, [
            _createTextVNode(" Solutions "),
            _hoisted_23
          ], 34)
        ]),
        _createElementVNode("div", {
          style: {"width":"138px"},
          onMouseenter: _cache[38] || (_cache[38] = () => { this.active = ''; })
        }, [
          _createVNode(_component_ContactUsButton, {
            classNames: "header-contact",
            onLinkTo: _ctx.linkTo,
            routeInfo: { path:'/contactUs' }
          }, null, 8, ["onLinkTo"])
        ], 32)
      ], 32),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("img", {
          onClick: _cache[40] || (_cache[40] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          src: _imports_2,
          class: "header-logo-more pointer"
        }),
        _hoisted_25,
        _createVNode(_component_ContactUsButton, {
          onClick: _cache[41] || (_cache[41] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          classNames: "header-contact-Tablet",
          onLinkTo: _ctx.linkTo,
          routeInfo: { path:'/contactUs' }
        }, null, 8, ["onLinkTo"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("img", {
          onClick: _cache[42] || (_cache[42] = () => { this.mobileMenuActive = !this.mobileMenuActive; }),
          src: _imports_3,
          class: "header-logo-more pointer"
        }),
        _hoisted_27,
        _hoisted_28
      ])
    ])
  ]))
}